import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAlertsStore = defineStore('alerts', () => {
  const alerts = ref([]);
  const defaultAlert = {
    type: 'success',
    message: '<< SUCCESS MESSAGE >>',
  };

  const showAlert = alert => {
    const indexedAlert = {
      id: alerts.value.length,
      ...JSON.parse(JSON.stringify(defaultAlert)),
      ...alert,
    };
    alerts.value.unshift(indexedAlert);
    if (alert.type !== 'success') return;
    setTimeout(() => {
      hideAlert(indexedAlert);
    }, 7000);
  };
  const hideAlert = alert => {
    const index = alerts.value.findIndex(e => e.id === alert.id);
    if (index === -1) return;
    alerts.value.splice(index, 1);
  };

  return { alerts, showAlert, hideAlert };
});
